import sdata from './_/sdata'

export default function (context, val) {
    let name = val;
    let data = context.state[name].data;
    context.state[name].visible = false;
    context.dispatch(name + '/set', sdata(data));
    context.state[name].rebind = false;
    setTimeout(() => {
        context.state[name].rebind = true;
    });
}